'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = create;

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _CreationActionTypes = require('../actionTypes/CreationActionTypes');

var _CreationActionTypes2 = _interopRequireDefault(_CreationActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = new _immutable.Map({
  requestState: RequestState.NOT_REQUESTED,
  userCreated: false,
  userOnly: null,
  createdHubId: null,
  creatorId: null,
  statusCode: null,
  statusMessage: null
});

function create() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _CreationActionTypes2.default.CREATION_ATTEMPTED:
      return state.merge({
        requestState: RequestState.REQUESTED
      });
    case _CreationActionTypes2.default.CREATION_SUCCEEDED:
      return state.merge({
        requestState: RequestState.SUCCEEDED,
        userCreated: payload.userCreated,
        createdHubId: payload.createdHubId,
        creatorId: payload.creatorId,
        userOnly: payload.userOnly
      });
    case _CreationActionTypes2.default.CREATION_FAILED:
      return state.merge({
        requestState: RequestState.FAILED.setStatusCode(payload.status).setStatusMessage(payload.statusMessage),
        statusCode: payload.status,
        statusMessage: payload.statusMessage
      });
    case _CreationActionTypes2.default.RESET_CREATION:
      return state.merge(initialState);
    default:
      return state;
  }
}
module.exports = exports['default'];